import React, { useEffect } from 'react'
import swal from 'sweetalert';
import { Link } from 'react-router-dom';
import useDelete from '../customHooks/useDelete';
import { toast } from 'react-toastify';
import dayjs from 'dayjs';
import { StringConvert } from '../components/StringConvert';



const truncateText = (text, maxLength) => {
    if (text) {
        if (text.length <= maxLength) {
            return text;
        }
        return text.slice(0, maxLength) + '...';
    }
    return text;
};


const BlogsCard = ({ data, alldata, deleted }) => {
    const { id, blog_image, blog_paragraph, blog_slug, blog_title, blog_schedule } = data

    // Function to replace specific special characters
    function replaceSpecialCharacters(str) {
        if (!str) return ''; // Handle undefined or null input
        return str
            .replace(/&amp;/g, '&') // Replace encoded ampersand
            .replace(/&lt;/g, '<') // Replace encoded less-than
            .replace(/&gt;/g, '>') // Replace encoded greater-than
            .replace(/&quot;/g, '"') // Replace encoded double quotes
            .replace(/&#39;/g, "'"); // Replace encoded single quotes
    }

    // Replace special characters in blog_paragraph
    const cleanedParagraph = replaceSpecialCharacters(blog_paragraph);
    const formattedDate = dayjs(blog_schedule).format('MMMM D, YYYY');
    const handleDelete = () => {
        swal({
            title: "Are you sure?",
            text: "Are you sure that you want to delete?",
            buttons: true,
            icon: "warning",
            dangerMode: true,
        })
            .then(willDelete => {
                if (willDelete) {
                    swal("Successfully Delete", "", "success");
                    apiMethodDelete(`blogs/delete/${id}`)
                }

            });
    }
    const [resDelete, apiMethodDelete] = useDelete()
    useEffect(() => {
        if (resDelete.data) {
            const { message } = resDelete.data
            const update = alldata.filter((item) => item.id !== id)
            deleted(update)
            toast.success(message);
        }
    }, [resDelete.data])

    const maxLength = 200;
    const truncatedText = truncateText(cleanedParagraph, maxLength);

    return (
        <div className='BlogsCard relative p-2 shadow-custom rounded-[10px] bg-[#A38560]/10'>
            <div className='closeButton cursor-pointer absolute bg-[#FFCEDA] w-[1.5rem] h-[1.5rem] p-[.5rem] top-[.7rem] right-[.7rem] grid place-items-center rounded-full z-10' onClick={handleDelete}>
                <svg className='w-full h-full' width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M15.8612 1.34766L0.951172 16.2567M15.8612 16.2577L0.951172 1.34863" stroke="#ED2656" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
            </div>
            <Link className="BlogsCardMain" to={`/blogs/edit/${id}`}>
                <div className="BlogsCard__left ">
                    <img src={blog_image} className='w-full h-[9rem] object-cover rounded-3xl mb-1' alt="1.png" />
                </div>
                <div className="BlogsCard__leftRight ">
                    <div className="h2 text-[1.2rem] capitalize leading-[1.2] mb-1 font-Cinzel">{blog_title.split(" ").slice(0, 3).join(" ")}...</div>
                    <div className="text-[#393946] text-[.7rem] leading-[1.5] mb-1">
                        {StringConvert(truncatedText.split(" ").slice(0, 10).join(" "))}
                    </div>
                    <ul className='list'>
                        <li className='text-primary flex justify-between items-center'><span className='font-Cinzel'>{formattedDate}</span></li>
                    </ul>
                </div>
            </Link>
        </div>
    )
}

export default BlogsCard
